const defaultTimeout = process.env.REACT_APP_DEFAULT_TIMEOUT_IN_MINUTE ?? 15;

export const MAX_IDLE_TIME = (defaultTimeout as number) * 60 * 1000; // Manulifehnw security protocol 15 minutes
export const MODAL_COUNTDOWN_TIME = 0.2 * 60 * 1000;
export const MODAL_POPUP_TIME = MAX_IDLE_TIME - MODAL_COUNTDOWN_TIME;
export const DATE_FORMAT = 'YYYY-MM-DD';
